import { UserType } from '../../user';
import { useCurrentUser } from './useCurrentUser';

export const useIsLoggedIn = (): boolean => {
  const u = useCurrentUser();
  return u.type !== UserType.Guest;
};
